var map = {
	"./ara": [
		27984,
		4307
	],
	"./ara.ts": [
		27984,
		4307
	],
	"./chi": [
		81956,
		913
	],
	"./chi.ts": [
		81956,
		913
	],
	"./dan": [
		6737,
		7127
	],
	"./dan.ts": [
		6737,
		7127
	],
	"./dut": [
		37795,
		9925
	],
	"./dut.ts": [
		37795,
		9925
	],
	"./eng": [
		98822
	],
	"./eng.ts": [
		98822
	],
	"./fin": [
		10491,
		2222
	],
	"./fin.ts": [
		10491,
		2222
	],
	"./fre": [
		20277,
		5020
	],
	"./fre.ts": [
		20277,
		5020
	],
	"./ger": [
		80928,
		1626
	],
	"./ger.ts": [
		80928,
		1626
	],
	"./gre": [
		29242,
		6008
	],
	"./gre.ts": [
		29242,
		6008
	],
	"./ita": [
		8002,
		8806
	],
	"./ita.ts": [
		8002,
		8806
	],
	"./jpn": [
		56250,
		4563
	],
	"./jpn.ts": [
		56250,
		4563
	],
	"./nor": [
		31825,
		1169
	],
	"./nor.ts": [
		31825,
		1169
	],
	"./por": [
		72967,
		7383
	],
	"./por.ts": [
		72967,
		7383
	],
	"./rum": [
		64134,
		181
	],
	"./rum.ts": [
		64134,
		181
	],
	"./rus": [
		21000,
		4955
	],
	"./rus.ts": [
		21000,
		4955
	],
	"./spa": [
		25620,
		9128
	],
	"./spa.ts": [
		25620,
		9128
	],
	"./swe": [
		59791,
		6330
	],
	"./swe.ts": [
		59791,
		6330
	],
	"./tha": [
		9801,
		9724
	],
	"./tha.ts": [
		9801,
		9724
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 11434;
module.exports = webpackAsyncContext;